import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { OuterWrapper } from './components/GroupTitle';

export const CardWrapper = styled.article`
  display: block;
  border-radius: 5px;
  border: 1px solid var(--oc-border);
  margin: 0 0 10px;
  background: var(--oc-body-background);

  &.widget {
    /* Map widget CSS variables to internal OC/OGM variables */
    --oc-border: var(--widget-divider-color);
    --oc-line-secondary: var(--widget-divider-color);
    --oc-bg-grey: var(--widget-accent-background-color);
    --oc-box-shadow: var(--widget-divider-color);
    --oc-primary-white: var(--widget-text-color);
    --oc-text-body: var(--widget-text-color);
    --oc-primary-green: var(--widget-cta-primary-color);
    --oc-secondary-green: var(--widget-cta-background-color);
    --oc-body-background: var(--widget-body-background-color);

    --ogm-text-body: var(--widget-text-color);
    --ogm-timberwolves: var(--widget-text-color);
    --ogm-mavericks: var(--widget-child-background-color);
    --ogm-bg-grey: var(--widget-accent-background-color);
    --ogm-border-grey: var(--widget-divider-color);
    --ogm-electric-emerald: var(--widget-cta-primary-color);
    --ogm-pelicans-rebrand: var(--widget-text-color);

    /* Map to CXY design tokens */
    --cxy-color-interactive-primary: var(--widget-cta-primary-color);
    --cxy-color-interactive-secondary-subtle: var(--widget-cta-background-color);
    --cxy-color-content-default: var(--widget-text-color);
    --cxy-color-border-subtle: var(--widget-divider-color);
    --cxy-color-container-inverse: var(--widget-background-color);
    --cxy-color-container-default: var(--widget-accent-background-color);

    /* Button theming - map widget variables to matches-coupon button variables */
    --mc-button-border-radius: var(--widget-button-border-radius, 3px);
    --mc-button-background: var(--widget-button-background, #f2f5f6);
    --mc-button-background-hover: var(--widget-button-background-hover, #66f1b8);
    --mc-button-selected-background: var(--widget-button-selected-background, #00e889);
    --mc-button-selected-text: var(--widget-button-selected-text, #ffffff);
    --mc-button-border: var(--widget-button-border, none);

    /* Optional button dimensions - GroupWrapper sets these dynamically, but widget can provide fallbacks */
    --oc-best-odds-height: var(--widget-button-height, 40);
  }
`;

export const AccordionHeader = styled.div`
  --arrow-right-position: 15px;
  background: var(--ogm-mavericks);
  border-bottom: 1px solid var(--oc-line-secondary);
  border-radius: 5px;
  padding: 12px 25px 11px 10px;
  color: var(--ogm-text-body);
  user-select: none;
  width: 100%;
  position: relative;

  &[aria-expanded='false'] {
    border-radius: 5px 5px 5px 5px;
  }

  &[aria-expanded='true'] {
    border-radius: 5px 5px 0 0;
  }

  @media (min-width: 768px) {
    padding: 12px 25px 11px 20px;
  }
`;

export const AccordionText = styled.a`
  font-family: var(--ogm-font-family-2);
  color: var(--ogm-text-body);
  font-weight: var(--cxy-fontWeight-bold);
  font-size: var(--cxy-fontSize-xl);
  line-height: 20px;
  text-transform: uppercase;

  &:visited,
  &:link {
    color: var(--ogm-text-body);
    text-decoration: none;
  }

  &:hover {
    @media (min-width: 1024px) {
      text-decoration: underline;
    }
  }
`;

export const StaticEventName = styled.span`
  font-family: var(--ogm-font-family-2);
  color: var(--ogm-text-body);
  font-weight: var(--cxy-fontWeight-bold);
  font-size: var(--cxy-fontSize-xl);
  line-height: 20px;
  text-transform: uppercase;
`;

export const arrow = css`
  cursor: pointer;

  &:after {
    content: '';
    border: solid black;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(-135deg);
    transition:
      transform 0.25s ease-in-out,
      top 0.25s ease-in-out;
    position: absolute;
    right: var(--arrow-right-position);
    top: calc(50% - 5px);
  }

  &[aria-expanded='false']:after {
    transform: rotate(45deg);
  }
  &[aria-expanded='true']:after {
    transform: rotate(-135deg);
    top: calc(50% - 2px);
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
`;

export const GroupWrapper = styled.div<{ numberOfColumns: number; renderBadge: boolean }>`
  --oc-best-odds-width: 65;
  --oc-columns-number: ${({ numberOfColumns }) => numberOfColumns};
  --oc-columns-gap: 5;

  @media (min-width: 768px) {
    --oc-best-odds-width: ${({ renderBadge }) => (renderBadge ? 100 : 65)};
    --oc-columns-gap: 10;
  }

  width: 100%;

  &:first-of-type ${OuterWrapper} {
    border-top-width: 0;
  }
`;

export const EventLink = styled.a`
  font-family: var(--ogm-font-family-2);
  font-style: normal;
  font-weight: 400;
  font-size: var(--cxy-fontSize-s);
  line-height: 16px;
  text-align: right;
  color: var(--cxy-color-interactive-secondary-subtle);
  display: flex;
  width: 100%;
  justify-content: flex-start;
  text-decoration: none;
  margin: 10px;
  span[class^='ArrowWrapper'] {
    position: relative;
    margin-left: 2px;
  }
  :hover {
    text-decoration: underline;
  }
`;
